import ApplicationAdapter from './application';

class TasAssistanceAdapter extends ApplicationAdapter {
  async updateTasAssistanceAmount(tasAssistanceId: string, amount: number, reason: string) {
    // @ts-expect-error stop using adapters
    const url = this.buildURL('tas-assistances', tasAssistanceId) + '/update-amount';

    return await this.ajax(url, 'PATCH', {
      data: {
        amount: amount,
        reason: reason,
      },
    });
  }
}

export default TasAssistanceAdapter;
